import { notification } from '@ergolabs/ui-kit';
import React, { FC, ReactNode } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { addresses$ } from '../../../api/addresses/addresses';
import { useObservable } from '../../hooks/useObservable';

export interface CopyVerifiedAddressProps {
  readonly children?: ReactNode | ReactNode[] | string;
}

export const CopyVerifiedAddress: FC<CopyVerifiedAddressProps> = ({
  children,
}) => {
  const [addresses] = useObservable(addresses$);

  return (
    <CopyToClipboard
      text={JSON.stringify(addresses)}
      onCopy={() =>
        notification.success({ message: 'Addresses copied successfully' })
      }
    >
      {children}
    </CopyToClipboard>
  );
};
